import { render, staticRenderFns } from "./block-admin-documents.vue?vue&type=template&id=c5984330&scoped=true&lang=pug"
import script from "./block-admin-documents.vue?vue&type=script&lang=js"
export * from "./block-admin-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5984330",
  null
  
)

export default component.exports